import React from "react";
import CourseGrid from "../section-component/course-card/CourseGrid";
import CompareCoursesCTA from "../section-component/course-compare/CompareCoursesCTA";
import FaqSection from "../section-component/faq-section/FaqSection";
import SupportSection from "../section-component/support-section/SupportSection";
import Footer from "../../../components/footer/Footer";
import Navbar from "../../../components/navbar/Navbar";
import LiveChat from "../section-component/live-chat/LiveChat";
import CourseCard from "./course-card/CourseCard";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const CourseIndex = () => {

    return (
        <>
            
             
            {/* <CourseGrid /> */}
            <CourseCard />
            {/* <CompareCoursesCTA /> */}
            <FaqSection />
            <SupportSection />

            
        </>
    );
};

export default CourseIndex;